import { koComponent } from '../ko-utils';
import $api from '../api';
import { extensionIdsByHostname, getExtensionIdByHostname, sendMessageToExtensionAsync } from '../utils/extension';

class ExtensionTester {
    constructor(params) {
        this.period = params.period || 0;
        this.initialPeriodCheck = params.initialPeriodCheck || 2000;
        this.reload = params.reload;
        this.parentPage = params.parentPage;

        this.extensionIsInstalled = ko.observable(false);
        this.isThisProjectInExtension = ko.observable(false);

        this.checkIfInstalled(this.initialPeriodCheck);

        if (this.period > 0) {
            this.periodInterval = setInterval(() => {
                this.checkIfInstalled(0);
            }, this.period);
        }

        this.downloadLink = getExtensionDownloadLink();
    }

    checkIfInstalled(timeout) {
        setTimeout(() => {
            //const getProperExtensionId = () => {
            //    return `chrome-extension://${getExtensionIdByHostname()}/images/test.png`;
            //};

            //const fullChromeExtUrl = getProperExtensionId();

            //fetch(fullChromeExtUrl).then(() => {
            //    this.extensionIsInstalled(true);

            //    clearInterval(this.periodInterval);
            //}).catch(() => {
            //    this.extensionIsInstalled(false);
            //});

            checkExtensionIsInstalledAsync().then(res => {
                this.extensionIsInstalled(res);

                res && clearInterval(this.periodInterval);
            });

            const replyHandler = (msg) => {
                if (msg.data.type == 'pfruits_extension_installed') {
                    this.extensionIsInstalled(true);
                    this.isThisProjectInExtension(auth.project.UniqueCode == msg.data.projectCode);

                    clearInterval(this.periodInterval);
                }
            }
            window.addEventListener('message', replyHandler);

            setTimeout(() => {
                window.postMessage('pfruitsExtensionLoadedCheck');
            }, timeout);
        }, timeout);
    }

    async loadProjectToExtension(connectedMessage) {
        const response = await sendMessageToExtensionAsync({
            type: 'open_tab',
            blank: true,
            url: auth.project.BaseUrl,
            connectedMessage: connectedMessage,
            workspace: {
                uniqueCode: auth.project.UniqueCode,
                name: auth.project.Name,
                supportedLanguages: auth.project.SupportedLanguages,
                baseUrl: auth.project.BaseUrl
            }
        });

        if (response && response.ok) {
            this.isThisProjectInExtension(true);
        }

        //let replyInterval = null;

        //window.addEventListener('message', (msg) => {
        //    if (msg.data == 'pf_extension_project_loaded') {
        //        clearTimeout(replyInterval);

        //        TRACK_EVENT('Projects', 'Start extension testing');

        //        window.open(auth.project.BaseUrl, '_blank');

        //        this.isThisProjectInExtension(true);
        //    }
        //});

        //window.postMessage({ loadProductFruitsProject: true, projectCode: auth.project.UniqueCode, baseUrl: auth.project.BaseUrl, supportedLanguages: auth.project.SupportedLanguages });

        //replyInterval = setTimeout(() => {
        //    alert('An error has occured, check if Product Fruits extension is installed properly.')
        //}, 1000);
    }

    unloadProjectFromExtension() {
        TRACK_EVENT('Projects', 'Stop extension testing');
        window.postMessage({ unload: true });
        this.checkIfInstalled(500);
    }

    dispose() {
        clearInterval(this.periodInterval);
    }
}

export default koComponent('extension-tester', ExtensionTester);

export function checkExtensionIsInstalledAsync() {
    return new Promise((success, error) => {
        const fullChromeExtUrl = `chrome-extension://${getExtensionIdByHostname()}/images/test.png`;

        fetch(fullChromeExtUrl).then(() => {
            success(true);
        }).catch(() => {
            success(false);
        });
    });
}

export function getExtensionDownloadLink() {
    return 'https://chrome.google.com/webstore/detail/product-fruits-presenter/' + getExtensionIdByHostname();
}